// Start VDR Section

export const VDR_GROUPS_REQUEST = "VDR_GROUPS_REQUEST";
export const VDR_GROUPS_SUCCESS = "VDR_GROUPS_SUCCESS";
export const VDR_GROUPS_FAIL = "VDR_GROUPS_FAIL";
export const VDR_COMPANY_REQUEST = "VDR_COMPANY_REQUEST";
export const VDR_COMPANY_SUCCESS = "VDR_COMPANY_SUCCESS";
export const VDR_COMPANY_FAIL = "VDR_COMPANY_FAIL";
export const VDR_LEVEL_REQUEST = "VDR_LEVEL_REQUEST";
export const VDR_LEVEL_SUCCESS = "VDR_LEVEL_SUCCESS";
export const VDR_LEVEL_FAIL = "VDR_LEVEL_FAIL";
export const VDR_HOME_REQUEST = 'VDR_HOME_REQUEST'; 
export const VDR_HOME_SUCCESS = 'VDR_HOME_SUCCESS'; 
export const VDR_HOME_FAIL = 'VDR_HOME_FAIL'; 
export const VDR_HOME_SUCCESS_FILTER = 'VDR_HOME_SUCCESS_FILTER'; 

export const VDR_UPLOAD_IMAGE_REQUEST = 'VDR_UPLOAD_IMAGE_REQUEST';
export const VDR_UPLOAD_IMAGE_SUCCESS = 'VDR_UPLOAD_IMAGE_SUCCESS';
export const VDR_UPLOAD_IMAGE_FAIL = 'VDR_UPLOAD_IMAGE_FAIL';

export const PUBLIC_IP_REQUEST = 'PUBLIC_IP_REQUEST';
export const PUBLIC_IP_SUCCESS = 'PUBLIC_IP_SUCCESS';
export const PUBLIC_IP_FAIL = 'PUBLIC_IP_FAIL';

export const VDR_SINGLE_COMPANY_REQUEST = 'VDR_SINGLE_COMPANY_REQUEST';
export const VDR_SINGLE_COMPANY_SUCCESS = 'VDR_SINGLE_COMPANY_SUCCESS';
export const VDR_SINGLE_COMPANY_FAIL = 'VDR_SINGLE_COMPANY_FAIL';


export const PDF_LINK_REQUEST = 'PDF_LINK_REQUEST';
export const PDF_LINK_SUCCESS = 'PDF_LINK_SUCCESS';


export const MEDIA_MODEL_REQUEST = 'MEDIA_MODEL_REQUEST';
export const MEDIA_MODEL_OPEN = 'MEDIA_MODEL_OPEN';
export const MEDIA_MODEL_CLOSE = 'MEDIA_MODEL_CLOSE';

export const MEDIA_DATA_REQUEST = 'MEDIA_DATA_REQUEST';
export const MEDIA_DATA_SUCCESS = 'MEDIA_DATA_SUCCESS';
export const MEDIA_DATA_FAIL = 'MEDIA_DATA_FAIL';


export const DATA_20_YEARS_REQUEST = 'DATA_20_YEARS_REQUEST';
export const DATA_20_YEARS_SUCCESS = 'DATA_20_YEARS_SUCCESS';
export const DATA_20_YEARS_FAIL = 'DATA_20_YEARS_FAIL';

export const DATA_20_YEARS_QUARTERLY_REQUEST = 'DATA_20_YEARS_QUARTERLY_REQUEST';
export const DATA_20_YEARS_QUARTERLY_SUCCESS = 'DATA_20_YEARS_QUARTERLY_SUCCESS';
export const DATA_20_YEARS_QUARTERLY_FAIL = 'DATA_20_YEARS_QUARTERLY_FAIL';

export const QUARTERLY_REVIEW_REQUEST = 'QUARTERLY_REVIEW_REQUEST';
export const QUARTERLY_REVIEW_SUCCESS = 'QUARTERLY_REVIEW_SUCCESS';
export const QUARTERLY_REVIEW_FAIL = 'QUARTERLY_REVIEW_FAIL';

export const PEER_TO_PEER_REQUEST = 'PEER_TO_PEER_REQUEST';
export const PEER_TO_PEER_SUCCESS = 'PEER_TO_PEER_SUCCESS';
export const PEER_TO_PEER_FAIL = 'PEER_TO_PEER_FAIL';

export const SORT_DATA_REQUEST = 'SORT_DATA_REQUEST';
export const SORT_DATA_SUCCESS = 'SORT_DATA_SUCCESS';
export const SORT_DATA_FAIL = 'SORT_DATA_FAIL';

export const SORT_DATA_UPDATE_REQUEST = 'SORT_DATA_UPDATE_REQUEST';
export const SORT_DATA_UPDATE_SUCCESS = 'SORT_DATA_UPDATE_SUCCESS';
export const SORT_DATA_UPDATE_FAIL = 'SORT_DATA_UPDATE_FAIL';

export const FAVORITE_REQUEST = 'FAVORITE_REQUEST';
export const FAVORITE_SUCCESS = 'FAVORITE_SUCCESS';
export const FAVORITE_FAIL = 'FAVORITE_FAIL';

export const EMPLOYEE_REQUEST = 'EMPLOYEE_REQUEST';
export const EMPLOYEE_SUCCESS = 'EMPLOYEE_SUCCESS';
export const EMPLOYEE_FAIL = 'EMPLOYEE_FAIL';

export const SEGMENT_REQUEST = 'SEGMENT_REQUEST';
export const SEGMENT_SUCCESS = 'SEGMENT_SUCCESS';
export const SEGMENT_FAIL = 'SEGMENT_FAIL';

export const SEGMENT_ASSIGN_REQUEST = 'SEGMENT_ASSIGN_REQUEST';
export const SEGMENT_ASSIGN_SUCCESS = 'SEGMENT_ASSIGN_SUCCESS';
export const SEGMENT_ASSIGN_FAIL = 'SEGMENT_ASSIGN_FAIL';
export const QUARTERLY_REVIEW_RESET = 'QUARTERLY_REVIEW_RESET';

export const QUARTERLY_SEGMENT_REQUEST = 'QUARTERLY_SEGMENT_REQUEST';
export const QUARTERLY_SEGMENT_SUCCESS = 'QUARTERLY_SEGMENT_SUCCESS';
export const QUARTERLY_SEGMENT_RESET = 'QUARTERLY_SEGMENT_RESET';
export const QUARTERLY_SEGMENT_FAIL = 'QUARTERLY_SEGMENT_FAIL';

export const VDR_HOME_COMPANIES_REQUEST = 'VDR_HOME_COMPANIES_REQUEST';
export const VDR_HOME_COMPANIES_SUCCESS = 'VDR_HOME_COMPANIES_SUCCESS';
export const VDR_HOME_COMPANIES_SUCCESS_FILTER = 'VDR_HOME_COMPANIES_SUCCESS_FILTER';
export const VDR_HOME_COMPANIES_FAIL = 'VDR_HOME_COMPANIES_FAIL';


// End VDR Section